import { InputHTMLAttributes, ReactNode, useId, useState } from "react";

export interface EnterpriseInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  trailingIcon?: ReactNode;
}

export default function EnterpriseInputField({
  label,
  error,
  trailingIcon,
  id,
  className = "",
  onFocus,
  onBlur,
  disabled,
  ...inputProps
}: EnterpriseInputProps) {
  const generatedId = useId();
  const inputId = id || generatedId;
  const errorId = `${inputId}-error`;
  const [focused, setFocused] = useState(false);

  const fieldStyle = error
    ? "border-[#B63434] ring-[3px] ring-[#FFE5E5]"
    : focused
      ? "border-bblue ring-[3px] ring-[#ECF2FB]"
      : "border-[#E4E6EA]";

  return (
    <div className="my-3 w-full">
      <label
        htmlFor={inputId}
        className={`block text-sm font-SatoshiM ${
          focused ? "text-[#222B34]" : "text-bash"
        }`}
      >
        {label}
      </label>

      <div
        className={`mt-2 flex h-8 items-center gap-2 rounded-md border px-3 py-1.5 ${fieldStyle} ${
          disabled ? "bg-[#F1F2F4]" : "bg-white"
        }`}
      >
        <input
          {...inputProps}
          id={inputId}
          disabled={disabled}
          aria-invalid={Boolean(error)}
          aria-describedby={error ? errorId : inputProps["aria-describedby"]}
          className={`h-full min-w-0 w-full flex-1 bg-transparent p-0 text-sm leading-4 font-SatoshiM text-[#222B34] placeholder:text-bash outline-none disabled:cursor-not-allowed ${className}`}
          onFocus={(event) => {
            setFocused(true);
            onFocus?.(event);
          }}
          onBlur={(event) => {
            setFocused(false);
            onBlur?.(event);
          }}
        />

        {trailingIcon}
      </div>

      {error && (
        <p
          id={errorId}
          className="mt-1 text-sm font-SatoshiR text-ERROR"
          role="alert"
        >
          {error}
        </p>
      )}
    </div>
  );
}
